import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
export const Sticky = styled.div.withConfig({
  displayName: "Aside__Sticky",
  componentId: "sc-1iss08-0"
})(["position:sticky;top:", ";margin:0 auto;margin-bottom:30px;transition:top 0.25s cubic-bezier(0.49,0.42,0.52,0.98);button{margin-left:0;}", ";", ""], props => props.omniNavState === 'opened' ? '155px' : '95px', minMediaQueries.miniDesktop`
    max-width: 330px;
  `, minMediaQueries.desktop`
    margin-left: auto;
    margin-bottom: 0;
  `);
export const AsideWatchlistBlock = styled.div.withConfig({
  displayName: "Aside__AsideWatchlistBlock",
  componentId: "sc-1iss08-1"
})(["max-width:100%;margin:0 auto;padding-bottom:32px;", ""], minMediaQueries.miniDesktop`
    max-width: ${`${grid(6)}px`};
  `);
export const AsideBottomAdsBlock = styled.div.withConfig({
  displayName: "Aside__AsideBottomAdsBlock",
  componentId: "sc-1iss08-2"
})(["height:40%;margin:0 auto 24px;"]);
export const AdBlockWrapper = styled.div.withConfig({
  displayName: "Aside__AdBlockWrapper",
  componentId: "sc-1iss08-3"
})(["width:auto;height:auto;margin-bottom:30px;background-color:#fff;"]);
export const AdBlockWrapperVertical = styled.div.withConfig({
  displayName: "Aside__AdBlockWrapperVertical",
  componentId: "sc-1iss08-4"
})(["width:auto;height:auto;margin-top:24px;margin-bottom:24px;background-color:#fff;"]);
export const AdBlock = styled.div.withConfig({
  displayName: "Aside__AdBlock",
  componentId: "sc-1iss08-5"
})(["width:300px;margin:0 auto;"]);